module.exports = __webpack_public_path__ + "img/slider2.3b19b2b3.jpg";